import React from 'react';
import { cloneDeep } from 'lodash';
import { FixMe } from '@utils/types';
import { useMappingState } from '../tableMappingProvider';
import { ColoredValue, JsonDataWrapper } from './styles';
import transformJSON from './jsonTransform';

export interface JsonDataViewProps {
  jsonData: { [i: string]: FixMe }[];
}

const ArrayItem = ({
  arr,
  init = true,
  comma,
}: {
  arr: FixMe[];
  comma?: boolean;
  init?: boolean;
}) => {
  const startBracket = '[';
  const endBracket = ']';

  return (
    <div>
      <div>
        <ColoredValue type="bracket">{startBracket}</ColoredValue>
      </div>
      {arr.map((currentValue, i) => {
        const useComma = i !== arr.length - 1;
        const valueMargin = !init ? 24 : 0;
        if (Array.isArray(currentValue)) {
          return (
            <div
              style={{
                marginLeft: valueMargin,
              }}
            >
              <ArrayItem arr={currentValue} comma={useComma} init={false} />
            </div>
          );
        }
        if (typeof currentValue === 'object' && !!currentValue) {
          return (
            <div
              style={{
                marginLeft: valueMargin,
              }}
            >
              <JsonItem json={currentValue} init comma={useComma} />
            </div>
          );
        }
        const inNullValue = currentValue === null || currentValue === undefined;
        return (
          <div
            style={{
              display: 'flex',
              whiteSpace: 'nowrap',
              marginLeft: valueMargin,
            }}
          >
            <ColoredValue type={inNullValue ? 'null' : (typeof currentValue as FixMe)}>
              {/* eslint-disable-next-line no-nested-ternary */}
              {typeof currentValue === 'boolean'
                ? String(currentValue)
                : inNullValue
                ? 'null'
                : currentValue}
            </ColoredValue>
            <ColoredValue>{(useComma && ',') || null}</ColoredValue>
          </div>
        );
      })}
      <div>
        <ColoredValue type="bracket">
          <span style={(init && { position: 'absolute', left: 0 }) || undefined}>
            {endBracket}
            <span style={{ color: 'black' }}>{(comma && ',') || null}</span>
          </span>
        </ColoredValue>
        {init && <div style={{ visibility: 'hidden' }}>{endBracket},</div>}
      </div>
    </div>
  );
};

const JsonItem = ({
  json,
  init = true,
  comma,
  renames,
}: {
  json: { [i: string]: FixMe };
  init?: boolean;
  comma?: boolean;
  renames?: FixMe;
}) => {
  const jsonKeys = Object.keys(json);
  const startBracket = Array.isArray(json) ? '[' : '{';
  const endBracket = Array.isArray(json) ? ']' : '}';
  return (
    <div>
      <div>
        <ColoredValue type="bracket">{startBracket}</ColoredValue>
      </div>
      {jsonKeys.map((key, i) => {
        const columnName = key;
        const useComma = i !== jsonKeys.length - 1;
        const currentValue = json[key];

        const isRenamed = !!(renames && renames[key]) && key !== 'traits';
        const valueMargin = init ? 24 : 0;
        if (typeof currentValue === 'object' && !!currentValue) {
          return (
            <div
              style={{
                whiteSpace: 'nowrap',
                marginLeft: valueMargin,
                display: 'flex',
                position: 'relative',
              }}
            >
              <span>
                <ColoredValue renamed={isRenamed}>{columnName} </ColoredValue>:
              </span>
              <div
                style={{
                  paddingLeft: 4,
                  width: '100%',
                }}
              >
                {Array.isArray(currentValue) ? (
                  <ArrayItem arr={currentValue} init />
                ) : (
                  <JsonItem
                    json={currentValue}
                    init={false}
                    comma={useComma}
                    renames={renames && renames[key]}
                  />
                )}
              </div>
            </div>
          );
        }
        const inNullValue = currentValue === null || currentValue === undefined;
        return (
          <div
            style={{
              display: 'flex',
              whiteSpace: 'nowrap',
              marginLeft: valueMargin,
            }}
          >
            <ColoredValue renamed={isRenamed} type={(key === 'type' && 'typeKey') || undefined}>
              {columnName}
            </ColoredValue>
            <ColoredValue> :&nbsp;</ColoredValue>
            <ColoredValue type={inNullValue ? 'null' : (typeof currentValue as FixMe)}>
              {/* eslint-disable-next-line no-nested-ternary */}
              {typeof currentValue === 'boolean'
                ? String(currentValue)
                : inNullValue
                ? 'null'
                : currentValue}
            </ColoredValue>
            <ColoredValue>{(useComma && ',') || null}</ColoredValue>
          </div>
        );
      })}
      <div>
        <ColoredValue type="bracket">
          <span style={(!init && { position: 'absolute', left: 0 }) || undefined}>
            {endBracket}
            <span style={{ color: 'black' }}>{(comma && ',') || null}</span>
          </span>
        </ColoredValue>
        {!init && <div style={{ visibility: 'hidden' }}>{endBracket},</div>}
      </div>
    </div>
  );
};

const JsonDataView: React.FC<JsonDataViewProps> = ({ jsonData }: JsonDataViewProps) => {
  const { renamedRows, constantsConfig } = useMappingState();
  const constantsJson = constantsConfig.reduce(
    (acc: FixMe, { key, value }: FixMe) => {
      acc.json = { ...acc.json, [key]: value };
      acc.constants = [...acc.constants, key];
      return acc;
    },
    { json: {}, constants: [] },
  );
  const jdata = cloneDeep(jsonData.length === 0 ? [{}] : jsonData);
  jdata[0].traits = { ...jdata[0].traits, ...constantsJson.json };
  const data: FixMe[] = jdata.map((v) =>
    transformJSON(v, constantsJson.constants, undefined, { traits: renamedRows }),
  );

  return (
    <JsonDataWrapper>
      {data.map((json: { values: { [i: string]: string }; renames: { [i: string]: string } }) => (
        <div>
          <JsonItem json={json.values} renames={json.renames} />
        </div>
      ))}
    </JsonDataWrapper>
  );
};

export default JsonDataView;
